var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100EyeBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6383 21.1953C30.4983 20.9729 27.1558 15.75 22 15.75C16.8442 15.75 13.5017 20.9729 13.3617 21.1953C13.2887 21.3115 13.25 21.446 13.25 21.5832C13.25 21.7205 13.2887 21.8549 13.3617 21.9711C13.5017 22.1935 16.8442 27.4164 22 27.4164C27.1558 27.4164 30.4983 22.1935 30.6383 21.9711C30.7113 21.8549 30.75 21.7205 30.75 21.5832C30.75 21.446 30.7113 21.3115 30.6383 21.1953ZM22 25.9581C18.4002 25.9581 15.7023 22.7192 14.8674 21.5832C15.9829 20.0325 17.448 18.7663 19.1439 17.8871C18.6359 18.5227 18.3576 19.3113 18.3542 20.1249C18.3542 21.0918 18.7383 22.0191 19.4221 22.7029C20.1058 23.3866 21.0331 23.7707 22 23.7707C22.9669 23.7707 23.8942 23.3866 24.5779 22.7029C25.2617 22.0191 25.6458 21.0918 25.6458 20.1249C25.6423 19.3136 25.3657 18.5271 24.8605 17.8922C26.5526 18.773 28.0155 20.0369 29.1326 21.5832C28.3006 22.7214 25.6115 25.9581 22 25.9581Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100EyeBlack);
export default __webpack_public_path__ + "static/media/100-eye-black.20708ccf4909d518975346003a76b16b.svg";
export { ForwardRef as ReactComponent };